module.exports = __webpack_public_path__ + "img/IMG_0374_L.948da3fa.webp";